import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_FAIL,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
} from "../constants/userConstants";

export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { ...state, loading: true, errorMessage: null, successMessage: null, infoMessage: null };
    case USER_LOGIN_SUCCESS:
      return { ...state, loading: false, errorMessage: null, successMessage: "Connexion réussie", infoMessage: "Bienvenue " + action.payload.firstName, userInfo: action.payload, warnMessage: action.payload.warn };
    case USER_LOGIN_FAIL:
      return { ...state, loading: false, errorMessage: action.payload, successMessage: null, infoMessage: null };
    case USER_LOGOUT:
      return {...state, errorMessage: null, successMessage: "Déconnexion réussie", infoMessage: null, userInfo: null};
    case USER_UPDATE_REQUEST:
      return { ...state, loading: true, errorMessage: null, successMessage: null, infoMessage: null };
    case USER_UPDATE_SUCCESS:
      return { ...state, loading: false, userInfo: action.payload, errorMessage: null, successMessage: "Mise à jour des informations réussie", infoMessage: null };
    case USER_UPDATE_FAIL:
      return { ...state, loading: false, errorMessage: action.payload, successMessage: null, infoMessage: null };
    default:
      return state;
  }
};

export const userRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_REGISTER_REQUEST:
      return { ...state, loading: true, errorMessage: null, successMessage: null, infoMessage: null };
    case USER_REGISTER_SUCCESS:
      return { ...state, loading: false, errorMessage: null, successMessage: "Création de l'utilisateur réussie", infoMessage: null };
    case USER_REGISTER_FAIL:
      return { ...state, loading: false, errorMessage: action.payload, successMessage: null, infoMessage: null };
    default:
      return state;
  }
};

